<script setup lang="ts">
import { RouterLink } from 'vue-router';
import BaseCard from '@/components/ui/BaseCard.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
</script>

<template>
  <BaseCard padding="md" data-testid="quick-actions">
    <template #header>
      <h2 class="text-section text-fg">Quick actions</h2>
    </template>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <RouterLink to="/portal/submit">
        <BaseButton variant="secondary" block>
          Submit an issue
        </BaseButton>
      </RouterLink>

      <RouterLink to="/issues/alert-rules">
        <BaseButton variant="secondary" block>
          Manage alert rules
        </BaseButton>
      </RouterLink>

      <RouterLink to="/board/residents/pending">
        <BaseButton variant="secondary" block>
          Review pending residents
        </BaseButton>
      </RouterLink>

      <RouterLink to="/reports">
        <BaseButton variant="secondary" block>
          View reports
        </BaseButton>
      </RouterLink>
    </div>
  </BaseCard>
</template>
